import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicButton,
    BaasicTable,
    TableFilter,
    EmptyState,
    QueryDropdown,
    DateQueryPicker
} from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content } from "core/layouts";

const FacilityOrderListTemplate = function({ facilityOrderListViewStore }) {
    
    const { 
        tableStore, 
        routes,
        queryUtility, 
        authorization, 
        // importStatusStore, 
        personStore, 
        facilityStore, 
        // nextOrderingDatePickerStore, 
        // nextDeliveryDatePickerStore, 
        dateOfServicePickerStore, 
        createdAtPickerStore,
        filterOnChange} = facilityOrderListViewStore;

    return (
        <ApplicationListLayout
            store={facilityOrderListViewStore}
            authorization={authorization}
        >
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} onChange={filterOnChange} isFetch={true} propertyName="facilityId" label="Facility"/>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={personStore} propertyName="accountManagerId" label="Account Manager"/>
                        </div>
                        {/* <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={importStatusStore} propertyName="importHeaderStatusId" label="Status"/>
                        </div> */}
                        {/* <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <label className="form__group__label">Ordering Date</label>
                            <DateQueryPicker store={nextOrderingDatePickerStore} queryUtility={queryUtility} propertyName="nextOrderingDate" />
                        </div> */}
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <label className="form__group__label">Date Of Service</label>
                            <DateQueryPicker store={dateOfServicePickerStore} queryUtility={queryUtility} propertyName="dateOfService" />
                        </div>
                        {/* <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <label className="form__group__label">Delivery Date</label>
                            <DateQueryPicker store={nextDeliveryDatePickerStore} queryUtility={queryUtility} propertyName="nextDeliveryDate" />
                        </div>                       */}
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <label className="form__group__label">BT Run Date</label>
                            <DateQueryPicker store={createdAtPickerStore} queryUtility={queryUtility} propertyName="createdAt" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_ORDER.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

FacilityOrderListTemplate.propTypes = {
    facilityOrderListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const {
        onEdit,
        onPreview,
        orderingCalendar,
        onDelete
    } = actions;
    if (
        !isSome(onEdit) && !isSome(onPreview) && !isSome(orderingCalendar) && !isSome(onDelete)
    )
        return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--edit u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.EDIT"
                        onlyIcon={true}
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--preview u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.PREVIEW"
                        onlyIcon={true}
                        onClick={() => onPreview(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(orderingCalendar) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--schedules--grey u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.ORDERING_CALENDAR"
                        onlyIcon={true}
                        onClick={() => orderingCalendar(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.delete : null
                        }
                        className="btn btn--icon is-delete"
                        icon="u-icon u-icon--delete u-icon--sml"
                        label="FACILITY_ORDER.LIST.BUTTON.DELETE"
                        onlyIcon={true}
                        onClick={() => onDelete(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(FacilityOrderListTemplate);